export function initializeAnalytics(measurementId) {
  if (!measurementId || typeof window === 'undefined') return;
  if (window.gtagInitialized) return;
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);} // eslint-disable-line
  window.gtag = window.gtag || gtag;
  gtag('js', new Date());
  gtag('config', measurementId);
  window.gtagInitialized = true;
}
  
export function trackEvent(eventName, params = {}) {
  if (typeof window === 'undefined' || !window.gtag) return;
  window.gtag('event', eventName, params);
}

export function trackListingView(listing, communities) {
  const community = communities.find(c => c.id === listing?.data?.community);
  trackEvent('listing_view', {
    listing_id: listing?.id,
    community: community?.data?.title,
    location: listing?.data?.location?.fullAddress,
    property_type: listing?.data?.property,
  });
}

export function trackWhatsappClick(listing) {
  trackEvent("whatsapp_click", {
    listing_id: listing?.id,
    community: listing?.data?.community,
    location: listing?.data?.location?.fullAddress,
  });
}
  

export function trackContactFormSubmitted(listing) {
  trackEvent('contact_form_submitted', {
    listing_id: listing?.id,
    community: listing?.data?.community,
    location: listing?.data?.location?.fullAddress,
    property_type: listing?.data?.property,
  });
}